module.exports = __webpack_public_path__ + "static/media/alphacolor-2FxEBbEO6Fo-unsplash.aa1e7b40.jpg";